import { createStore } from "vuex";
import aitools from "./aitools";

export default createStore({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    aitools,
  },
});
